import * as React from "react";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { HomeIcon } from "./components/HomeIcon";
import { MobilePluginMenuIcon } from "./components/MobilePluginMenuIcon";
import { Wrapper } from "./components/Wrapper";
import { IHeaderMobile } from "./HeaderMobile";
import { View } from "../../../../api/api";

export const HeaderMobileDefaultView = ({
  isKeypadHidden,
  triggerHomeRequest,
  triggerPluginRequest,
  homeAvailable,
  homeEnabled,
  pluginAvailable,
  pluginEnabled,
  pluginMenuButtonIcon,
  isLeftHandMode,
  view
}: IHeaderMobile) => {
  if (isKeypadHidden || view !== View.DEFAULT) {
    return null;
  }

  return (
    <Wrapper isLeftHandMode={isLeftHandMode}>
      {homeAvailable && (
        <HomeIcon
          onClick={homeEnabled ? triggerHomeRequest : null}
          disabled={!homeEnabled}
          data-e2e-id={E2EIdentifier.MOBILE_KEYPAD_HOME_BUTTON}
        />
      )}

      {pluginAvailable && (
        <MobilePluginMenuIcon
          onClick={pluginEnabled ? triggerPluginRequest : null}
          icon={pluginMenuButtonIcon}
          disabled={!pluginEnabled}
          data-e2e-id={E2EIdentifier.PLUGIN_MENU_BUTTON}
        />
      )}
    </Wrapper>
  );
};
